import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-muted" }
const _hoisted_2 = { class: "form-label fw-700" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "*", -1)
const _hoisted_4 = {
  key: 0,
  class: "invalid-feedback d-block mb-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelsInput = _resolveComponent("LabelsInput")!
  const _component_dp_field = _resolveComponent("dp-field")!
  const _component_BaseModalButton = _resolveComponent("BaseModalButton")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createBlock(_component_BaseModal, {
    "modal-id": _ctx.modalId,
    title: _ctx.$t('startUserMode'),
    "no-footer": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_GenericFormWrapper, {
        pageUI: _ctx.pageUI,
        submitData: _ctx.submitData,
        submitButtonTranslationKey: "startUserMode",
        hideFeedbackStatus: ""
      }, {
        content: _withCtx(({ errors }) => [
          _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('userModeExplanation')), 1),
          _createElementVNode("label", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.$t('userModeCustomerCodes')) + " ", 1),
            _hoisted_3
          ]),
          _createVNode(_component_dp_field, {
            name: "customerCodes",
            modelValue: _ctx.request.customer_codes,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.request.customer_codes) = $event)),
            rules: _ctx.validateCustomerCodes
          }, {
            default: _withCtx(({ value, handleChange }) => [
              _createElementVNode("div", {
                onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
              }, [
                _createVNode(_component_LabelsInput, {
                  modelValue: value,
                  placeholder: _ctx.$t('userModeCustomerCodes'),
                  disabled: _ctx.pageUI.isSubmitting(),
                  "onUpdate:modelValue": ($event: any) => {handleChange($event); _ctx.onFormDataChanged()}
                }, null, 8, ["modelValue", "placeholder", "disabled", "onUpdate:modelValue"])
              ], 32)
            ]),
            _: 1
          }, 8, ["modelValue", "rules"]),
          (errors.customerCodes)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(errors.customerCodes), 1))
            : _createCommentVNode("", true)
        ]),
        buttons: _withCtx(() => [
          _createVNode(_component_BaseModalButton, {
            mode: "close",
            class: "btn btn-outline-primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["pageUI", "submitData"])
    ]),
    _: 1
  }, 8, ["modal-id", "title"]))
}